import * as React from 'react';
import { connect } from 'react-redux';
import { getNextStep, setIsMobileInfo } from '../../../../actions/claimHistoryActionsV2';
import ClaimsTile from '../ClaimHistoryComponents/ClaimsTile';
import ClaimsProgressBar from '../ClaimHistoryComponents/ClaimsProgressBar';
import ClaimsSteps from '../ClaimHistoryComponents/ClaimsSteps';
import { Card } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

class ClaimOverView extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            carHire: false
        };

        this.handleClick = this.handleClick.bind(this);
        this.handleToggle = this.handleToggle.bind(this);
        this.getClaimStatusClass = this.getClaimStatusClass.bind(this);
        this.getClaimStatusMessage = this.getClaimStatusMessage.bind(this);
        this.getClaimStatus = this.getClaimStatus.bind(this);
        this.hasCarHire = this.hasCarHire.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    async handleClick() {
        this.props.handleGetNextStep();
    }

    async handleToggle() {
        this.setState({ carHire: !this.state.carHire });
    }

    getClaimStatusClass() {
        let cssClass = '';
        switch (this.props.claimSubmit.selectedClaim.claimStatusCategory) {
            case 'Approved': cssClass = 'Approved'; break;
            case 'Pending': cssClass = 'Pending'; break;
            case 'Cancelled': cssClass = 'Cancelled'; break;
            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    getClaimStatusMessage() {
        let message: any = null;
        switch (this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase()) {
            case 'claim closed': {
                message = <>
                    Thanks for letting us know that you don’t want to proceed with this claim. We’ve cancelled it on our side. We’ve noted this as an incident on your profile, so that we have a complete history for you.
                </>
                break;
            }
            case 'claim not approved':
            case 'claim not authorised': {
                message = <>
                    Unfortunately, this claim isn’t valid. We’ve sent you a detailed explanation via email, so please check your inbox.
                </>
                break;
            }
            case 'claim cancelled (internal kp error)': {
                message = <>
                    Claim cancelled due to an internal error.
                    <br /><br />
                    Look out for a new claim for this incident in your list of claims. If you don’t see your new claim, request a call back.
                </>
                break;
            }
        }
        return message;
    }

    getClaimStatus(claimStepDescription: String) {
        if (claimStepDescription.toLowerCase() === "claim completed") {
            return this.props.claimSubmit.claimProgress.claimSteps.filter(x => (x.isComplete) && x.claimStepDescription.toLowerCase() == claimStepDescription.toLowerCase()).length > 0 ? true : false;
        }
        return this.props.claimSubmit.claimProgress.claimSteps.filter(x => ((x.isComplete)) && x.claimStepDescription.toLowerCase() == claimStepDescription.toLowerCase()).length === this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() == claimStepDescription.toLowerCase()).length ? true : false;
    }

    getStepActive(claimStepDescription: String) {
        return this.props.claimSubmit.claimProgress.claimSteps.filter(x => (x.isComplete || x.isCurrentStatus) && x.claimStepDescription.toLowerCase() == claimStepDescription.toLowerCase()).length > 0 ? true : false;
    }

    hasCarHire() {
        return this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() == "car hire").length > 0 ? true : false;
    }

    async handleBackClick() {
        this.props.handleSetIsMobileInfo(false);
    }

    render() {
        const { profile } = this.props;
        let steps = <div></div>;
        let nrToUse = 0
        if (profile.personalClaims !== undefined && profile.personalClaims !== "") {
            steps = this.props.claimSubmit.claimProgress.claimSteps
                .map((step, index) => {
                    let nextStep = index + 1;
                    if (nextStep <= this.props.claimSubmit.claimProgress.claimSteps.length - 1) {
                        let carHireCheck = this.props.claimSubmit.claimProgress.claimSteps[nextStep].claimStepDescription.toLowerCase()
                        let carHireStepSkip = index + 2
                        if (carHireStepSkip <= this.props.claimSubmit.claimProgress.claimSteps.length - 1) {
                            if (carHireCheck === "car hire") {
                                carHireCheck = this.props.claimSubmit.claimProgress.claimSteps[carHireStepSkip].claimStepDescription.toLowerCase()
                            }
                        }
                        if (carHireCheck !== step.claimStepDescription.toLowerCase()) {
                            nrToUse += 1
                            if (step.claimStepDescription.toLowerCase() === "overview") {
                                nrToUse -= 1
                                return <>
                                </>
                            }
                            else if (step.claimStepDescription.toLowerCase() === "car hire") {
                                return <ClaimsSteps isActive={this.hasCarHire()} title="Car hire" isCarHire={true} />
                            }
                            else {
                                let sub = ""
                                switch (step.claimStepDescription.toLowerCase) {
                                    case "claim registration":
                                        sub = "Schweet news alert...Your claim has been..."
                                        break;
                                    case "towing":
                                        sub = "Ready, set... Tow! Here’s some info on..."
                                        break;
                                    case "assessment":
                                        sub = "Let’s take a look at your car’s damage..."
                                        break;
                                    case "claim processing":
                                        sub = "Oh looky, it’s time to process your..."
                                        break;
                                    case "repairs":
                                        sub = "Time to give your wheels some TLC..."
                                        break;
                                    case "claim completed":
                                        sub = "Yay, your claim’s done and dusted..."
                                        break;
                                    default: sub = "";
                                        break;
                                }
                                return <ClaimsSteps isSelected={this.getStepActive(step.claimStepDescription)} done={this.getClaimStatus(step.claimStepDescription)} subtitle={sub} title={step.claimStepDescription} nr={nrToUse} />
                            }
                        }
                    }
                    else {
                        nrToUse += 1
                        let sub = ""
                        switch (step.claimStepDescription.toLowerCase) {
                            case "claim registration":
                                sub = "Schweet news alert...Your claim has been..."
                                break;
                            case "towing":
                                sub = "Ready, set... Tow! Here’s some info on..."
                                break;
                            case "assessment":
                                sub = "Let’s take a look at your car’s damage..."
                                break;
                            case "claim processing":
                                sub = "Oh looky, it’s time to process your..."
                                break;
                            case "repairs":
                                sub = "Time to give your wheels some TLC..."
                                break;
                            case "claim completed":
                                sub = "Yay, your claim’s done and dusted..."
                                break;
                            default: sub = "";
                                break;
                        }
                        return <ClaimsSteps isSelected={this.getStepActive(step.claimStepDescription)} done={this.getClaimStatus(step.claimStepDescription)} subtitle={sub} title={step.claimStepDescription} nr={nrToUse} />
                    }
                });
        }

        const stepsList = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.overallEstProgressBar !== null).length > 0
        const claimStepDescription = this.props.claimSubmit.selectedClaimProgressStep.claimStepDescription.toLowerCase();
        const claimStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === claimStepDescription)[0];
        const claimStatusClass = this.getClaimStatusClass();
        const claimStatusMessage = this.getClaimStatusMessage();

        return (
            <>
                {isMobile &&
                    <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                }
                <div id="ClaimOverView">
                    <Card className="content-box-padding-20px-with-box-shadow">
                        <div className="row noma">
                            <div className="col nopa">
                                <ClaimsTile isClaimStatus={true} />
                                {stepsList && claimStepDescription && (claimStep.overallEstCompletionDate || claimStep.overallEstLatestDate) &&
                                    <>
                                        <ClaimsProgressBar />
                                        <hr className="mt-15px mb-20px claims-v2-hr-2px" />
                                    </>
                                }
                                <div className="row noma">
                                    <div className="col nopa">
                                        <span className={'dot float-left ' + claimStatusClass}></span>
                                        <p className={claimStatusClass + '-text' + ' status-text'}>Status: {this.props.claimSubmit.selectedClaim.claimStatus}</p>
                                        {claimStatusClass === "Cancelled" &&
                                            <p className="float-left mt-20px mr-10px mb-5px">{claimStatusMessage}</p>
                                        }
                                    </div>
                                </div>
                                <hr className="claims-v2-hr-2px" />
                                <p className="text-16 mb-10px"><b>Claim steps</b></p>
                                <p className="font-weight-normal mb-15px">Tap on a step to see more details about your claim’s progress</p>
                                {steps}
                            </div>
                        </div>
                    </Card>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleSetIsMobileInfo: (flag) => dispatch(setIsMobileInfo(flag))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimOverView);
